import { useCallback, useEffect, useRef, useState } from "react";

// Popover de día para las retículas de 12 meses (calendario de leads y vista
// Año del calendario). Solo maneja estado, posición y tiempos — el contenido
// lo pinta cada consumidor, porque un día de leads y un día de calendario no
// muestran lo mismo.
//
// Dos cosas que costaron ajustar y conviene no perder:
//   - Hover con RETARDO. Abrir al instante hacía que cruzar la retícula
//     disparara paneles todo el tiempo y tapara los días vecinos. El clic
//     sigue abriendo de inmediato.
//   - Posición que se VOLTEA. Antes se clavaba con un Math.min contra el
//     borde de la ventana, y en los meses de abajo el panel terminaba encima
//     del propio día que ibas a leer.
export function useDayPopover({ width = 256, height = 288, openDelay = 350 } = {}) {
  const [popover, setPopover] = useState(null); // { key, x, y, data }
  const hideTimer = useRef(null);
  const openTimer = useRef(null);

  useEffect(
    () => () => {
      clearTimeout(hideTimer.current);
      clearTimeout(openTimer.current);
    },
    []
  );

  const posicion = useCallback(
    (rect) => {
      const margen = 8;
      const cabeAbajo = rect.bottom + 4 + height <= window.innerHeight - margen;
      const cabeDerecha = rect.left + width <= window.innerWidth - margen;
      return {
        x: cabeDerecha ? rect.left : Math.max(margen, rect.right - width),
        y: cabeAbajo
          ? rect.bottom + 4
          : Math.max(margen, rect.top - height - 4),
      };
    },
    [width, height]
  );

  const show = useCallback(
    (key, rect, data, { inmediato = false } = {}) => {
      clearTimeout(hideTimer.current);
      clearTimeout(openTimer.current);
      if (!data) return;
      const abrir = () => setPopover({ key, ...posicion(rect), data });
      if (inmediato) abrir();
      else openTimer.current = setTimeout(abrir, openDelay);
    },
    [posicion, openDelay]
  );

  const scheduleHide = useCallback(() => {
    clearTimeout(openTimer.current);
    clearTimeout(hideTimer.current);
    hideTimer.current = setTimeout(() => setPopover(null), 150);
  }, []);

  const cancelHide = useCallback(() => clearTimeout(hideTimer.current), []);

  const close = useCallback(() => {
    clearTimeout(openTimer.current);
    clearTimeout(hideTimer.current);
    setPopover(null);
  }, []);

  return { popover, show, scheduleHide, cancelHide, close };
}
